import { useState, useEffect } from "react";
import { FaQuoteLeft, FaStar, FaChevronLeft, FaChevronRight } from "react-icons/fa";

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      name: "Rahul Mehta",
      designation: "Marketing Executive",
      review:
        "At first, I wasn't sure if I should apply online, but the process was very easy and safe. I could fill out my application in just a few minutes because the interface was so clear. The quick approval and transfer of funds really helped me deal with a problem that needed to be fixed right away. It's a good choice for anyone who needs money quickly.",
    },
    {
      name: "Sneha Kapoor",
      designation: "Business Analyst",
      review:
        "I thought this service was very easy to use because I like things that are simple. There was no extra paperwork, and everything was made clear. I was kept up to date at every step, which made me feel good about the process. The money was sent out quickly, which helped me pay my bills on time. It was an easy and stress-free process.",
    },
    {
      name: "Vikas Jain",
      designation: "Operations Manager",
      review:
        "This platform did exactly what it said it would do for me, and time was very important to me. I didn't have to wait days for a response because the approval process was quick. I knew what to expect at every step of the process, and it was all clear. It's a good choice when you need money quickly and don't want to deal with any problems.",
    },
    {
      name: "Karan Malhotra",
      designation: "Sales Manager",
      review:
        "I was really impressed by how fast it worked. I thought it would take a few days to apply, but everything was done much faster. There weren't any extra steps, and the whole thing felt like it worked well. It helped me take care of an important need without any stress. If you need quick and reliable help, I would tell you to use it.",
    },
    {
      name: "Amit Gupta",
      designation: "Software Engineer",
      review:
        "I've used other loan services before, but this one stood out because it was quick and easy. The application process was easy, and I got approved much faster than I thought I would. There were no secret steps or delays, which made the whole thing go smoothly. It really helped me deal with a lack of money without missing any of my daily tasks.",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const goToPrev = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  // Get current and next testimonial for desktop
  const getVisibleTestimonials = () => {
    const first = currentIndex;
    const second = (currentIndex + 1) % testimonials.length;
    return { first, second };
  };

  const { first, second } = getVisibleTestimonials();

  return (
    <section className="w-full py-16 md:py-20 lg:py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16 lg:mb-20">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#2C3E50] mb-4 font-['Inter']">
            Our Happy Customers
          </h2>
          <p className="text-gray-600 text-base md:text-lg lg:text-xl font-['Inter']">
            Real feedback from customers who have trusted My Salary Loan
          </p>
        </div>

        {/* Slider Container */}
        <div className="relative px-12 md:px-16 lg:px-20">
          {/* Mobile View - Single Card */}
          <div className="lg:hidden relative h-[500px]">
            {testimonials.map((testimonial, index) => (
              <div
                key={`mobile-${index}`}
                className={`absolute inset-0 transition-all duration-500 ease-in-out ${
                  index === currentIndex
                    ? "opacity-100 z-10"
                    : "opacity-0 z-0"
                }`}
              >
                <div className="bg-gradient-to-br from-[#A9F9EE] to-[#7DD4D0] rounded-3xl p-8 md:p-10 shadow-2xl h-full flex flex-col">
                  <div className="absolute top-6 right-6 text-[#3D4A7C] text-5xl md:text-6xl opacity-20">
                    <FaQuoteLeft />
                  </div>

                  <div className="flex gap-1 mb-6">
                    {[...Array(5)].map((_, i) => (
                      <FaStar key={i} className="text-yellow-500 text-lg md:text-xl" />
                    ))}
                  </div>

                  <p className="text-gray-700 text-base md:text-lg leading-relaxed mb-8 font-['Inter'] flex-grow">
                    {testimonial.review}
                  </p>

                  <div className="border-t-2 border-[#3D4A7C]/20 pt-6 mt-auto">
                    <h4 className="text-xl md:text-2xl font-bold text-[#2C3E50] font-['Inter']">
                      {testimonial.name}
                    </h4>
                    <p className="text-[#3D4A7C] text-base md:text-lg font-semibold font-['Inter']">
                      {testimonial.designation}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Desktop View - Two Cards Side by Side */}
          <div className="hidden lg:grid lg:grid-cols-2 gap-8 lg:gap-10">
            {/* First Card */}
            <div className="transition-all duration-500 ease-in-out">
              <div className="bg-gradient-to-br from-[#A9F9EE] to-[#7DD4D0] rounded-3xl p-10 lg:p-12 shadow-2xl h-full flex flex-col hover:scale-105 transition-transform duration-300">
                <div className="absolute top-8 right-8 text-[#3D4A7C] text-6xl opacity-20">
                  <FaQuoteLeft />
                </div>

                <div className="flex gap-1 mb-6">
                  {[...Array(5)].map((_, i) => (
                    <FaStar key={i} className="text-yellow-500 text-xl" />
                  ))}
                </div>

                <p className="text-gray-700 text-lg leading-relaxed mb-8 font-['Inter'] flex-grow">
                  {testimonials[first].review}
                </p>

                <div className="border-t-2 border-[#3D4A7C]/20 pt-6 mt-auto">
                  <h4 className="text-2xl font-bold text-[#2C3E50] font-['Inter']">
                    {testimonials[first].name}
                  </h4>
                  <p className="text-[#3D4A7C] text-lg font-semibold font-['Inter']">
                    {testimonials[first].designation}
                  </p>
                </div>
              </div>
            </div>

            {/* Second Card */}
            <div className="transition-all duration-500 ease-in-out">
              <div className="bg-gradient-to-br from-[#A9F9EE] to-[#7DD4D0] rounded-3xl p-10 lg:p-12 shadow-2xl h-full flex flex-col hover:scale-105 transition-transform duration-300">
                <div className="absolute top-8 right-8 text-[#3D4A7C] text-6xl opacity-20">
                  <FaQuoteLeft />
                </div>

                <div className="flex gap-1 mb-6">
                  {[...Array(5)].map((_, i) => (
                    <FaStar key={i} className="text-yellow-500 text-xl" />
                  ))}
                </div>

                <p className="text-gray-700 text-lg leading-relaxed mb-8 font-['Inter'] flex-grow">
                  {testimonials[second].review}
                </p>

                <div className="border-t-2 border-[#3D4A7C]/20 pt-6 mt-auto">
                  <h4 className="text-2xl font-bold text-[#2C3E50] font-['Inter']">
                    {testimonials[second].name}
                  </h4>
                  <p className="text-[#3D4A7C] text-lg font-semibold font-['Inter']">
                    {testimonials[second].designation}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={goToPrev}
            className="absolute left-0 top-1/2 -translate-y-1/2 w-10 h-10 md:w-14 md:h-14 rounded-full bg-[#3D4A7C] text-white flex items-center justify-center shadow-lg hover:bg-[#2d3a6c] transition-all hover:scale-110 z-20"
            aria-label="Previous testimonial"
          >
            <FaChevronLeft className="text-xl" />
          </button>
          <button
            onClick={goToNext}
            className="absolute right-0 top-1/2 -translate-y-1/2 w-10 h-10 md:w-14 md:h-14 rounded-full bg-[#3D4A7C] text-white flex items-center justify-center shadow-lg hover:bg-[#2d3a6c] transition-all hover:scale-110 z-20"
            aria-label="Next testimonial"
          >
            <FaChevronRight className="text-xl" />
          </button>

          {/* Dots Indicator */}
          <div className="flex justify-center gap-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`transition-all duration-300 rounded-full ${
                  index === currentIndex
                    ? "w-12 h-3 bg-[#3D4A7C]"
                    : "w-3 h-3 bg-gray-300 hover:bg-gray-400"
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
